module.exports = __webpack_public_path__ + "media/images/calendar/october-b741e7c405ca565163d8a2bd449d3f5e.jpg";